
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"20 9 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.748 27.889l-1.267 4.296h6.78a.34.34 0 01.354.332v.112l-.59 2.045a.441.441 0 01-.442.326H32.206l1.74-5.956-1.946.593.442-1.363 1.946-.593 2.447-8.355a.448.448 0 01.442-.326H39.9a.34.34 0 01.354.332v.113l-2.063 7.051 1.945-.592-.413 1.422-1.975.563z","fill":"#345D9D"}})])
          )
        }
      }
    